module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "id": "epigraph"
    }
  }, [_c('a', {
    attrs: {
      "id": "start"
    }
  }, [_vm._v("This nostalgia for a past often so eclectic as to be unlocatable historically is a facet of the modernist sensibility which has seemed increasingly suspect in recent decades. It is an ultimate refinement of the colonialist outlook: an imaginative exploitation of nonwhite cultures, whose moral life it drastically oversimplifies, whose wisdom it plunders and parodies. To that criticism there is no convincing reply. But to the criticism that the quest for ‘another form of civilization’ refuses to submit to the disillusionment of accurate historical knowledge, one can make an answer. It never sought such knowledge. The other civilizations are being used as models because they are available as stimulants to the imagination precisely because they are not accessible. They are both models and mysteries. Nor can this quest be dismissed as fraudulent on the grounds that it is insensitive to the political forces that cause human suffering…")])]), _c('a', {
    attrs: {
      "id": "start"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_vm._v("SUSAN SONTAG,"), _c('i', [_vm._v(" Approaching Artaud")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55dabda4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/6epigraph.vue
// module id = 78
// module chunks = 0